module.exports = __webpack_public_path__ + "img/msi-giftcard-mockup.21638d20.jpg";